function checkFooterPosition() {
  // 768px以下のときだけ実行
  if (window.innerWidth > 768) return

  const footer = document.querySelector('footer')
  const fixedBtn = document.querySelector('.fixed_btn')

  if (!footer || !fixedBtn) return

  const footerRect = footer.getBoundingClientRect()
  const windowHeight = window.innerHeight

  if (footerRect.top <= windowHeight + 60) {
    fixedBtn.classList.add('disabled')
  } else {
    fixedBtn.classList.remove('disabled')
  }
}

// 読み込み時
window.addEventListener('DOMContentLoaded', checkFooterPosition)
window.addEventListener('load', checkFooterPosition)

// スクロール時
window.addEventListener('scroll', checkFooterPosition)

// ウィンドウサイズ変更時もチェック（必要に応じて）
window.addEventListener('resize', checkFooterPosition)
